export enum STORE_SORTS {
  name = "name",
  createdAt = "createdAt",
}

export enum STORE_STATUS {
  CLOSED = 2, // closed
  LIVE = 1,
  SUSPENDED = 0, //off
  SOFT_SUSPENDED = 6,
  DRAFT = 3, // when merchant draft create store
  PENDING = 4,
  OFFLINE = 7,
  REJECTED = 5,
}

export enum SERVICE_SUPPORTS {
  PICKUP = "pickup",
  DINE_IN = "dine in",
  DELIVERY = "delivery",
  SPECIAL_EVENT = "special event",
}

export enum PRE_ORDER_SERVICE_SUPPORTS {
  PICKUP = "pickup",
  MERCHANT_OWN_FLEET = "seller_own_fleet",
}

export const SERVICE_SUPPORT_OPTIONS = [
  { value: SERVICE_SUPPORTS.PICKUP, label: "Pick-up" },

  { value: SERVICE_SUPPORTS.DELIVERY, label: "Delivery" },
];

export const PRE_ORDER_SERVICE_SUPPORT_OPTIONS = [
  { value: PRE_ORDER_SERVICE_SUPPORTS.PICKUP, label: "Pick-up" },

  { value: PRE_ORDER_SERVICE_SUPPORTS.MERCHANT_OWN_FLEET, label: "Merchant Own Fleet" },
];

export const CLONE_STORE_OPTIONS = [{ value: true, label: "Clone store with products" }];

export const BINARY_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export enum STORE_TYPE {
  FOOD_DELIVERY = "FOOD_DELIVERY",
  SURPLUS = "SURPLUS",
}

export const STORE_TYPE_OPTIONS = [
  { value: "FOOD_DELIVERY", label: "Food Delivery" },
  { value: "SURPLUS", label: "Surplus" },
];

export const DAY_OFF_OPTIONS = [{ value: true, label: "OFF" }];

export enum STORE_PENDING_TYPE {
  APPROVAL = "approval",
  ONBOARD = "onboard",
}
